const toStringOrNull = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
};

const readStoredValue = (key) => {
  if (typeof window === 'undefined') return null;

  try {
    const localValue = window.localStorage?.getItem?.(key);
    if (localValue && String(localValue).trim()) {
      return String(localValue).trim();
    }
  } catch {}

  try {
    const sessionValue = window.sessionStorage?.getItem?.(key);
    if (sessionValue && String(sessionValue).trim()) {
      return String(sessionValue).trim();
    }
  } catch {}

  return null;
};

export const resolveMessengerV2AuthSnapshot = ({ currentUser = null, isAuthorized = false } = {}) => {
  const resolvedCurrentUser =
    currentUser && typeof currentUser === 'object' ? currentUser : null;
  const authorized = isAuthorized === true;

  if (authorized) {
    return {
      isAuthorized: true,
      currentUserId: toStringOrNull(resolvedCurrentUser?.id),
      currentUserSlug: toStringOrNull(resolvedCurrentUser?.slug),
      currentUserName:
        toStringOrNull(resolvedCurrentUser?.name) ||
        toStringOrNull(resolvedCurrentUser?.email) ||
        null,
    };
  }

  return {
    isAuthorized: authorized,
    currentUserId:
      toStringOrNull(resolvedCurrentUser?.id) ||
      readStoredValue('id'),
    currentUserSlug:
      toStringOrNull(resolvedCurrentUser?.slug) ||
      readStoredValue('user-slug'),
    currentUserName:
      toStringOrNull(resolvedCurrentUser?.name) ||
      toStringOrNull(resolvedCurrentUser?.email) ||
      readStoredValue('user-name') ||
      readStoredValue('user-email') ||
      readStoredValue('email'),
  };
};

const messengerV2AuthSnapshot = {
  resolveMessengerV2AuthSnapshot,
};

export default messengerV2AuthSnapshot;
